import { useEffect, useState } from 'react'
import React from 'react'
import AOS from 'aos';
import BgOrg from '../Assets/HomePage/what-is-horizon1.webp'
import Org from '../Assets/HomePage/2018_1.webp'
import blobRed from '../Assets/blob3.webp'
import blobBlue from '../Assets/blob4.webp'

// Komponen utama 'What'
export default function What() {

    // useEffect untuk inisialisasi AOS (Animate On Scroll)
    // AOS digunakan untuk memberikan efek animasi saat elemen masuk ke dalam viewport.
    useEffect(() => {
        const AOS = require("aos");
        AOS.init({
          once: true, // Animasi hanya berjalan satu kali saat di-scroll
        });
      }, []);
    
    // useEffect ini digunakan untuk me-refresh AOS saat ada perubahan
    // pada komponen. Ini penting jika konten dimuat secara dinamis.
    useEffect(() => {
        if (AOS) {
          AOS.refresh();
        }
      });
    
    // Data untuk setiap huruf dan kata-kata kecilnya
    // Struktur data ini memudahkan pengelolaan konten dan looping di JSX.
    const zenithData = [
      { letter: 'Z', word: 'Zeal' },
      { letter: 'E', word: 'Elevation' },
      { letter: 'N', word: 'Never-give-up' },
      { letter: 'I', word: 'Indomitable' },
      { letter: 'T', word: 'Teamwork' },
      { letter: 'H', word: 'Hope' },
    ];

    // Mengembalikan (return) elemen-elemen JSX yang akan dirender
    return (
      // Fragmen React <>...</> digunakan untuk mengembalikan beberapa elemen
      // tanpa harus membungkusnya dalam satu <div> tambahan.
      <>
        {/* Kontainer utama dengan background biru muda.
            'w-full m-0' memastikan kontainer mengisi seluruh lebar halaman tanpa margin.
        */}
        <div className='w-full m-0 bg-[#E8F0F5]'>
          {/* Kontainer bagian dalam berwarna putih dengan efek shadow.
              'py-20 px-4' memberikan padding vertikal dan horizontal.
              'shadow-lg' menciptakan efek bayangan yang membuat kontainer terlihat terangkat.
          */}
          <div className="bg-white py-20 px-4 md:px-20 lg:py-32 shadow-lg">
            
            {/* Tampilan Desktop (Tampil di layar md: (768px) ke atas) */}
            {/* 'hidden' menyembunyikan div ini secara default.
                'md:flex' menampilkannya sebagai flexbox saat layar mencapai ukuran medium ke atas.
            */}
            <div className="hidden md:flex justify-center items-center h-fit">
              {/* Flexbox container untuk huruf-huruf secara horizontal
                  'space-x-4' memberikan jarak horizontal antar huruf.
              */}
              <div className="flex flex-row justify-center items-start space-x-4">
                  
                  {/* Bagian untuk Huruf Z */}
                  <div className="flex flex-col items-center justify-between h-[150px] md:h-[200px]">
                      {/* Placeholder 'invisible' untuk menjaga alignment vertikal pada huruf Z dan N */}
                      <span className="font-plusjakartasans text-sm md:text-base mb-1 invisible font-extrabold" style={{color: '#E08000'}}>Placeholder</span>
                      {/* Huruf kapital dengan font Amiri */}
                      <span className="font-amiri text-6xl md:text-8xl mb-2" style={{color: '#2B387D'}}>Z</span>
                      {/* Kata kecil di bawah huruf kapital */}
                      <span className="font-plusjakartasans text-sm md:text-base font-extrabold text-center" style={{color: '#E08000'}}>Zeal</span>
                  </div>
                  
                  {/* Bagian untuk Huruf E */}
                  <div className="flex flex-col items-center justify-between h-[150px] md:h-[200px]">
                      {/* Kata kecil di atas huruf kapital */}
                      <span className="font-plusjakartasans text-sm md:text-base mb-1 font-extrabold text-center" style={{color: '#E08000'}}>Elevation</span>
                      {/* Huruf kapital dengan font Amiri */}
                      <span className="font-amiri text-6xl md:text-8xl mb-2" style={{color: '#2B387D'}}>E</span>
                      {/* Placeholder 'invisible' untuk menjaga alignment vertikal */}
                      <span className="font-plusjakartasans text-sm md:text-base invisible font-extrabold" style={{color: '#E08000'}}>Placeholder</span>
                  </div>

                  {/* Bagian untuk Huruf N */}
                  <div className="flex flex-col items-center justify-between h-[150px] md:h-[200px]">
                      <span className="font-plusjakartasans text-sm md:text-base mb-1 invisible font-extrabold" style={{color: '#E08000'}}>Placeholder</span>
                      <span className="font-amiri text-6xl md:text-8xl mb-2" style={{color: '#2B387D'}}>N</span>
                      <span className="font-plusjakartasans text-sm md:text-base font-extrabold text-center" style={{color: '#E08000'}}>Never-give-up</span>
                  </div>

                  {/* Bagian untuk Huruf I */}
                  <div className="flex flex-col items-center justify-between h-[150px] md:h-[200px]">
                      <span className="font-plusjakartasans text-sm md:text-base mb-1 font-extrabold text-center" style={{color: '#E08000'}}>Indomitable</span>
                      <span className="font-amiri text-6xl md:text-8xl mb-2" style={{color: '#2B387D'}}>I</span>
                      <span className="font-plusjakartasans text-sm md:text-base invisible font-extrabold" style={{color: '#E08000'}}>Placeholder</span>
                  </div>

                  {/* Bagian untuk Huruf T */}
                  <div className="flex flex-col items-center justify-between h-[150px] md:h-[200px]">
                      <span className="font-plusjakartasans text-sm md:text-base mb-1 invisible font-extrabold" style={{color: '#E08000'}}>Placeholder</span>
                      <span className="font-amiri text-6xl md:text-8xl mb-2" style={{color: '#2B387D'}}>T</span>
                      <span className="font-plusjakartasans text-sm md:text-base font-extrabold text-center" style={{color: '#E08000'}}>Teamwork</span>
                  </div>

                  {/* Bagian untuk Huruf H */}
                  <div className="flex flex-col items-center justify-between h-[150px] md:h-[200px]">
                      <span className="font-plusjakartasans text-sm md:text-base mb-1 font-extrabold text-center" style={{color: '#E08000'}}>Hope</span>
                      <span className="font-amiri text-6xl md:text-8xl mb-2" style={{color: '#2B387D'}}>H</span>
                      <span className="font-plusjakartasans text-sm md:text-base invisible font-extrabold" style={{color: '#E08000'}}>Placeholder</span>
                  </div>
              </div>
            </div>
            
            {/* Tampilan Mobile (Tampil di layar mobile, disembunyikan di md: ke atas) */}
            {/* 'flex' menyalakannya secara default, 'md:hidden' menyembunyikannya di layar md: ke atas.
                'flex-col' mengatur layout menjadi vertikal.
            */}
            <div className="flex flex-col items-center justify-center space-y-8 md:hidden">
              {/* Looping data 'zenithData' untuk membuat setiap huruf secara otomatis */}
              {zenithData.map((item, index) => (
                // Kontainer untuk setiap pasangan huruf dan kata
                <div key={index} className="flex flex-col items-center">
                  {/* Huruf kapital */}
                  <span className="font-amiri text-6xl mb-2" style={{color: '#2B387D'}}>
                      {item.letter}
                  </span>
                  {/* Kata kecil, selalu di bawah huruf kapital di tampilan mobile */}
                  <span className="font-plusjakartasans text-sm font-extrabold text-center" style={{color: '#E08000'}}>
                      {item.word}
                  </span>
                </div>
              ))}
            </div>
            
          </div>
        </div>
      </>
    )
}